import axios from "axios";
import AlertStore from '@/stores/AlertStore'

import {ENDPOINT_TRIMESTRES, ENDPOINT_CURRENT_TRIMESTRE} from "../constants/endpoints";

let store = {
  debug: true,
  state: {
    trimestres: []
  },

  getAll() {
    if (this.state.trimestres.length === 0) {
      return axios.get(ENDPOINT_TRIMESTRES)
          .then(response => {
            this.state.trimestres = response.data;
            return this.state.trimestres;
          })
          .catch(error => AlertStore.pushError(error.response.data.message));
    } else {
      return new Promise(resolve => {
        resolve(this.state.trimestres);
      });
    }
  },
  getCurrentTrimestre(includeFenetreFermeture) {
      return axios.get(ENDPOINT_TRIMESTRES + ENDPOINT_CURRENT_TRIMESTRE, {params: {includeFenetreFermeture}})
          .then(response => {
            return response.data;
          })
          .catch(error => AlertStore.pushError(error.response.data.message));
  }
};

export default store;
